import { fromJS } from 'immutable';
import { getSortOrderArray } from '../local-storage/getSortOrderArray';
import { handleActions } from 'redux-actions';
import { SET_REALTIME_SORT_ORDER } from '../constants/actionTypes';
const initialState = fromJS(getSortOrderArray());
export default handleActions({
  [SET_REALTIME_SORT_ORDER](state, action) {
    return action.payload.sortOrder;
  }
}, initialState);